<template>
    <div class="root">
        <div class="hh-register-container">
            <div class="panel panel-default">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 section-title margin-top-30">
                            <h1 class="text-normal text-capitalize">
                                {{formTitle}}
                            </h1>
                        </div>
                    </div>
                    <div v-if="loading" class="section-body margin-top-50 margin-bottom-50">
                        <LoadingAnimation/>
                    </div>
                    <div class="section section-body" v-if="!loading">              
                        <div class="row margin-top-20" v-if="dataAnalysed">
                            <div class="col-sm-12 form margin-bottom-30">
                                <Step1 v-if="step === 1"
                                       @formSubmitted="formSubmitted"
                                       @componentLoading="componentLoading"
                                       @navigateNext="navigateNext"
                                       :userData="userData.dataStep1"
                                       :userRoles="userRoles"
                                       :upgradeTo="userData.upgradeTo"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Step1 from './steps/Step-1'
  import LoadingAnimation from '../../components/LoadingAnimation'
  import { scrollTop } from '../../utils/componentHelper'

  export default {
    name: 'Form',

    components: {
      Step1,
      LoadingAnimation,
    },

    props: {},

    data: () => {
      return {
        step: 1,
        loading: true,
        dataAnalysed: false,
        config: {},
        userData: {
          verified: null,
          upgradeTo: 'organizer',
          dataStep1: {},
          dataStep2: {},
          dataStep4: {
            business_type: null,
            business_name: null,
            url: null,
            identification_number: null,
            account_number: null,
            routing_number: null,
          },
        },
        userRoles: null,
      }
    },

    beforeMount () {
      if (_.isEmpty(this.profileData)) {
        this.$store.dispatch('profile/fetchData').then(() => {
          this.dataAnalysed = false
          this.loading = true
          this.analyseUserData()
        })
      } else {
        this.dataAnalysed = false
        this.loading = true
        this.analyseUserData()
      }
    },

    mounted () {
      this.loading = true
    },

    methods: {
      fillUserData () {
        this.userRoles = this.profileData.data.attributes.roles;
        this.identities = this.profileData.data.attributes.identities;

        this.fillDataStep1()
        this.fillDataStep4()
      },

      fillDataStep1 () {
        this.userData.dataStep1.email = this.profileData.data.attributes.email
        this.userData.dataStep1.first_name = this.profileData.data.attributes.first_name
        this.userData.dataStep1.last_name = this.profileData.data.attributes.last_name
        this.userData.dataStep1.verified = this.profileData.data.attributes.verified
           
      },

   
      fillDataStep4 () {
        if (!_.isEmpty(this.profileData.data.relations.payoutInformation)) {
          let accountData = this.profileData.data.relations.payoutInformation.data.attributes
          this.userData.dataStep4 = { ...accountData }
        }
        this.userData.dataStep4.business_name = this.profileData.data.attributes.business_name
      },

      fillConfigData () {
        if (!_.isEmpty(this.profileData.config)) {
          this.config = this.profileData.config
        }
      },

      fillStaticData () {
        if (!_.isEmpty(this.profileData.data.staticData)) {
          this.staticData = { ...this.staticData, ...this.profileData.data.staticData }
        }
      },

      analyseUserData () {
        if (!_.isEmpty(this.profileData)) {
          this.fillUserData()
          this.fillConfigData()
          this.fillStaticData()
        }

        if (!_.isEmpty(this.userRoles) && this.userRoles.includes('organizer')) {
          this.$store.commit('setAlert', {
            message: 'You already are a Fundraiser.',
            type: 'alert-danger'
          })

          this.$router.push({ name: 'create-campaign' })
        }

        this.dataAnalysed = true
        this.loading = false
      },

      navigateBack () {
          --this.step
            scrollTop()
      },

      navigateNext () {
          ++this.step
            scrollTop()
      },

      componentLoading (componentName, value) {
        this.componentsLoadingStatus[componentName] = value
      },

      formSubmitted () {
        this.loading = true
        this.$store.dispatch('profile/fetchData').then(() => {
          this.dataAnalysed = false
             if (this.userData.verified !== true) {
              window.location = "/email/verify";
              return;
            }
          this.analyseUserData()
        })
      },

    },

    computed: {
      ...mapGetters({
        profileData: 'profile/profileData',
        authUser: 'authUser',
      }),

      formTitle () {
        let defaultTitle = 'Upgrade'

        if (this.userData.upgradeTo === 'organizer') {
          return `Fundraiser ${defaultTitle}`
        }

        return 'Loading...'
      },

    },
  }
</script>

<style lang="scss" scoped>
    .root::v-deep {
        @import '../../../style/pages/register';
    }

    h1 {
      font-family: Circular Std;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 33px;
      letter-spacing: -0.01em;
      color: #000000;
    }
</style>
